import { __read } from "tslib";
import React, { useEffect, useState } from 'react';
import 'intersection-observer';
import { Barcode } from './layout/Barcode';
import { ProductListImage } from './components/ProductListImage';
import { isBrandedRevealImageCached } from './components/BrandedRevealImage';
// Icons.
import { FaComment, FaSearch } from 'react-icons/fa';
/** Server totalDisp: 9999 = unlimited; <= 0 with override absent = sold out. */
function isSoldOutByTotalDisp(totalDisp) {
    var value = totalDisp != null ? totalDisp : 0;
    return value !== 9999 && value <= 0;
}
var ProductListItem = function (props) {
    var product = props.product, quantityLabel = props.quantityLabel, showQuantity = props.showQuantity, showSoldQuantity = props.showSoldQuantity, showBarcode = props.showBarcode, baseUrl = props.baseUrl, handleShowStyleOrders = props.handleShowStyleOrders, imageUrlForProduct = props.imageUrlForProduct;
    var seasonCode = product.seasonCode, masterId = product.masterId, colorCode = product.colorCode;
    var imageSize = props.imageProfile === 'large' ? 'large' : 'small';
    var imageUrl = imageUrlForProduct
        ? imageUrlForProduct(product)
        : baseUrl + 'productimage/' + seasonCode + '/' + masterId + '/' + colorCode + '/' + imageSize + '?cache=10052021';
    quantityLabel = quantityLabel || 'Quantity';
    var _a = __read(useState(function () {
        return isBrandedRevealImageCached(imageUrl);
    }), 2), imageReady = _a[0], setImageReady = _a[1];
    var _b = __read(useState(false), 2), stickerVisible = _b[0], setStickerVisible = _b[1];
    useEffect(function () {
        var cached = isBrandedRevealImageCached(imageUrl);
        setImageReady(cached);
        if (!cached) {
            setStickerVisible(false);
        }
    }, [imageUrl]);
    useEffect(function () {
        if (!props.inBasket || !imageReady) {
            setStickerVisible(false);
            return;
        }
        var frame = requestAnimationFrame(function () { return setStickerVisible(true); });
        return function () { return cancelAnimationFrame(frame); };
    }, [props.inBasket, imageReady]);
    var getQuantity = function () {
        var master = product;
        var totalDisp = master.totalDisp || 0;
        if (props.quantityOveride) {
            return props.quantityOveride;
        }
        return totalDisp !== 9999 ? (totalDisp <= 0 ? 'Sold Out' : totalDisp) : (React.createElement("span", { className: "infiniteAvailability" }));
    };
    var mediaOverlayClass = props.inBasket && product.discontinued
        ? ' in-basketdiscontinued' + (stickerVisible ? ' in-basket--visible' : '')
        : (props.inBasket ? ' in-basket' : '') +
            (props.inBasket && stickerVisible ? ' in-basket--visible' : '') +
            (product.discontinued ? ' discontinued' : '');
    var showSoldOutBadge = props.quantityOveride == null && isSoldOutByTotalDisp(product.totalDisp);
    return (React.createElement("div", { className: "pl-item" },
        React.createElement("div", { className: 'pl-item__media' + mediaOverlayClass },
            (product.b2BMasterComment || product.b2BColorComment || product.styleNote || product.colorNote) && React.createElement("span", { className: "pl-item__comment-icon" },
                React.createElement(FaComment, null)),
            React.createElement("div", { className: "pl-item__image-stack" },
                React.createElement(ProductListImage, { key: imageUrl, src: imageUrl, alt: product.description || "".concat(masterId, " ").concat(colorCode), scrollPosition: props.scrollPosition, onLoad: function () { return setImageReady(true); } }),
                showSoldOutBadge && (React.createElement("span", { className: "pl-item__sold-out" }, "Sold Out")))),
        React.createElement("p", { className: "pl-item__text" },
            React.createElement("span", { className: "--highlighted" }, product.description),
            " ",
            product.colorName),
        React.createElement("p", { className: "pl-item__text" },
            product.masterId,
            " ",
            product.colorCode),
        props.getPrice && React.createElement("p", { className: "pl-item__text --italic" }, props.getPrice(product)),
        showBarcode && React.createElement(Barcode, { value: product.masterId }),
        showQuantity && product.colorBlocked !== 1 &&
            React.createElement("p", { className: "pl-item__text" },
                React.createElement("strong", null,
                    quantityLabel,
                    ": ",
                    getQuantity())),
        showSoldQuantity &&
            React.createElement("p", { className: "pl-item__text" },
                React.createElement("strong", { style: { color: "green" }, onClick: function (e) { return props.handleShowStyleOrders && props.handleShowStyleOrders(e, product); } },
                    React.createElement(FaSearch, null),
                    " ",
                    product.totalcolorsold),
                "/",
                product.qtysbbaskets + product.qtyb2bbaskets,
                "  ",
                product.totalmastersold),
        showQuantity && product.colorBlocked === 1 &&
            React.createElement("p", { className: "pl-item__text" },
                React.createElement("strong", null, "Blocked"))));
};
export default ProductListItem;
//# sourceMappingURL=ProductListItem.js.map